import type { ReactNode } from 'react';
import { Box, Button, Typography } from '@mui/material';
import * as Sentry from '@sentry/react';

/**
 * What a render error shows instead of a white page. Sentry.ErrorBoundary
 * reports the error (with its component stack) before this renders.
 */
export const CrashFallback = () => (
  <Box role="alert" sx={{ p: 4 }}>
    <Typography variant="h5" component="h1" gutterBottom>
      Something went wrong
    </Typography>
    <Typography sx={{ mb: 2 }}>Reload the page to carry on.</Typography>
    <Button variant="contained" onClick={() => window.location.reload()}>
      Reload
    </Button>
  </Box>
);

/** Catches render errors anywhere in the app, reports them, shows the fallback. */
const AppErrorBoundary = ({ children }: { children: ReactNode }) => (
  <Sentry.ErrorBoundary fallback={<CrashFallback />}>{children}</Sentry.ErrorBoundary>
);

export default AppErrorBoundary;
